module.exports = __webpack_public_path__ + "static/media/WAWorks-example.c282e97e.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/WAWorks-example.png
// module id = 360
// module chunks = 0